"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMoralisError = void 0;
var isMoralisError = function (error) {
    if (!(error instanceof Error)) {
        return false;
    }
    if (!error.isMoralisError) {
        return false;
    }
    return true;
};
exports.isMoralisError = isMoralisError;
//# sourceMappingURL=isMoralisError.js.map